import { Q2Game } from "../../net/proto/q2_game";
import Utility from "../../../../utility/utility";
import SpriteFrameHolder from "../../../public/ui/spriteFrameHolder";


const { ccclass, property, menu } = cc._decorator;

@ccclass
export default class Q2TableResultDetailScoreChangeItem extends cc.Component {

    @property(cc.Sprite)
    spriteIcon: cc.Sprite = null

    @property(cc.Label)
    labelScore: cc.Label = null

    @property(SpriteFrameHolder)
    spriteHodlerIcon: SpriteFrameHolder = null

    show(show: boolean, type?: number, score?: number){
        this.node.active = !!show
        if(show){
            let color = cc.Color.WHITE
            if(score >= 0){
                color = color.fromHEX('#FFFA69')
                this.labelScore.string = `+${score}`
            }else{
                color = color.fromHEX('#57F147')
                this.labelScore.string = `${score}`
            }
            this.labelScore.node.color = color
            this.fillSprite(type)
        }
    }

    fillSprite(type: number){
        this.spriteIcon.spriteFrame = this.spriteHodlerIcon.getSpriteFrameByKey(type.toString())
    }

}
